import { render } from "./MeuQrPage.vue?vue&type=template&id=627c8856&scoped=true"
import script from "./MeuQrPage.vue?vue&type=script&lang=js"
export * from "./MeuQrPage.vue?vue&type=script&lang=js"

import "./MeuQrPage.vue?vue&type=style&index=0&id=627c8856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627c8856"]])

export default __exports__